(() => {
  const mobileMedia = window.matchMedia('(max-width: 860px)');

  document.querySelectorAll('.cd13-collection-listing-layout').forEach((layout, index) => {
    const panel = Array.from(layout.children).find((element) =>
      element.classList.contains('cd13-collection-facets')
    );

    if (!panel || layout.querySelector('.cd13-mobile-filters-toggle')) return;

    const panelId = panel.id || `CollectionFilters-${index + 1}`;
    const activeCount = panel.querySelectorAll('.cd13-active-filter').length;

    panel.id = panelId;
    panel.classList.add('is-mobile-collapsible');

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'cd13-mobile-filters-toggle';
    button.setAttribute('aria-controls', panelId);
    button.setAttribute('aria-expanded', 'false');

    const label = document.createElement('span');
    label.className = 'cd13-mobile-filters-toggle__label';
    label.textContent = 'Filtres';

    if (activeCount > 0) {
      const count = document.createElement('span');
      count.className = 'cd13-mobile-filters-toggle__count';
      count.textContent = String(activeCount);
      count.setAttribute('aria-label', `${activeCount} filtre${activeCount > 1 ? 's' : ''} actif${activeCount > 1 ? 's' : ''}`);
      label.appendChild(count);
    }

    const icon = document.createElement('span');
    icon.className = 'cd13-mobile-filters-toggle__icon';
    icon.setAttribute('aria-hidden', 'true');

    button.append(label, icon);
    layout.insertBefore(button, panel);

    const setOpen = (open) => {
      panel.classList.toggle('is-open', open);
      button.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', String(open));
    };

    button.addEventListener('click', () => {
      setOpen(!panel.classList.contains('is-open'));
    });

    const syncViewport = () => {
      if (!mobileMedia.matches) setOpen(false);
    };

    if (typeof mobileMedia.addEventListener === 'function') {
      mobileMedia.addEventListener('change', syncViewport);
    } else if (typeof mobileMedia.addListener === 'function') {
      mobileMedia.addListener(syncViewport);
    }
  });
})();

(() => {
  document.querySelectorAll('.cd13-facets-form').forEach((form) => {
    if (form.dataset.autosubmit) return;
    form.dataset.autosubmit = 'true';

    const action = (form.getAttribute('action') || window.location.pathname).split('#')[0];
    form.setAttribute('action', `${action}#products`);

    form.addEventListener('change', (event) => {
      if (!event.target.matches('input[type="checkbox"]')) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    });
  });
})();
